import React, { useCallback, useState } from 'react'
import classNames from 'classnames'

import { footerItems } from '../constants'

import { ItemTitle } from './itemTitle'
import { Item } from './item'

export const Routes: React.FC = () => {
  const [active, setActive] = useState<number>()

  const onToggleRoutes = useCallback(
    (idx: number) => () => {
      setActive(prev => (idx === prev ? undefined : idx))
    },
    [],
  )

  return (
    <React.Fragment>
      {footerItems.map((item, idx) => (
        <div className="column small-12 medium-flex-20" key={idx}>
          <div
            className={classNames('footer_item', {
              active: idx === active,
            })}
          >
            <ItemTitle title={item.title} onOpen={onToggleRoutes(idx)} />
            <ul>
              {item.subPaths?.map((sub, _idx) => (
                <Item key={_idx} {...sub} />
              ))}
            </ul>
          </div>
        </div>
      ))}
    </React.Fragment>
  )
}
